import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    width="150"
    height="100"
    viewBox="0 0 150 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7_28072)">
      <path
        d="M95.7084 26.2662C95.7084 40.4964 84.2109 52.0323 70.028 52.0323C55.8451 52.0323 44.3477 40.4964 44.3477 26.2662C44.3477 12.0359 55.8451 0.5 70.028 0.5C84.2109 0.5 95.7084 12.0359 95.7084 26.2662Z"
        fill="#FFC00F"
      />
      <path
        d="M62.314 38.3731H66.8812V31.346H70.7206C75.6886 31.346 78.5787 28.3721 78.5787 24.0437C78.5787 19.7364 75.7413 16.6991 70.8366 16.6991H62.314V38.3731ZM66.8812 27.6737V20.4454H69.9611C72.5981 20.4454 73.8743 21.8847 73.8743 24.0437C73.8743 26.192 72.5981 27.6737 69.9822 27.6737H66.8812Z"
        fill="white"
      />
    </g>
    <g clip-path="url(#clip1_7_28072)">
      <path
        d="M83.4726 47.5233C83.66 47.2587 83.9065 47.0418 84.1924 46.8898C84.4783 46.7378 84.7956 46.655 85.119 46.6479C85.4425 46.6408 85.7631 46.7097 86.0553 46.849C86.3475 46.9883 86.6032 47.1943 86.802 47.4504L93.7809 45.0704L92.8134 48.7889L86.3345 50.4789C85.9289 50.7546 85.4394 50.8783 84.952 50.8282C84.4645 50.778 84.0103 50.5573 83.6688 50.2047C83.3274 49.8521 83.1206 49.3901 83.0847 48.8998C83.0488 48.4095 83.1861 47.9222 83.4726 47.5233Z"
        fill="#FFB8B8"
      />
      <path
        d="M138.288 99.2027C138.803 93.6453 140.223 88.2104 142.493 83.1149C143.126 81.6969 143.822 80.3101 144.582 78.9545C144.777 78.6057 144.243 78.2924 144.048 78.6411C141.284 83.5785 139.348 88.938 138.316 94.5055C138.029 96.0602 137.814 97.626 137.67 99.2027C137.633 99.6004 138.252 99.5979 138.288 99.2027Z"
        fill="#E6E6E6"
      />
      <path
        d="M146.081 79.9502C148.245 79.9502 150 78.1897 150 76.018C150 73.8463 148.245 72.0858 146.081 72.0858C143.917 72.0858 142.162 73.8463 142.162 76.018C142.162 78.1897 143.917 79.9502 146.081 79.9502Z"
        fill="#E6E6E6"
      />
      <path
        d="M138.689 99.3071C139.023 95.7018 139.944 92.1759 141.417 88.8702C141.828 87.9503 142.279 87.0506 142.772 86.1712C142.797 86.1252 142.803 86.0714 142.789 86.021C142.775 85.9707 142.742 85.9279 142.697 85.9015C142.652 85.8751 142.599 85.8673 142.548 85.8797C142.497 85.8921 142.453 85.9237 142.426 85.9679C140.633 89.171 139.377 92.648 138.707 96.2598C138.521 97.2685 138.382 98.2843 138.288 99.3071C138.264 99.5651 138.666 99.5635 138.689 99.3071H138.689Z"
        fill="#E6E6E6"
      />
      <path
        d="M143.745 86.8173C145.149 86.8173 146.287 85.6752 146.287 84.2663C146.287 82.8574 145.149 81.7153 143.745 81.7153C142.34 81.7153 141.202 82.8574 141.202 84.2663C141.202 85.6752 142.34 86.8173 143.745 86.8173Z"
        fill="#E6E6E6"
      />
      <path
        d="M138.183 99.0664C136.236 96.0178 134.801 92.669 133.936 89.1537C133.695 88.1751 133.5 87.187 133.35 86.1893C133.341 86.1378 133.313 86.0916 133.271 86.0607C133.229 86.0297 133.176 86.0162 133.125 86.0232C133.073 86.0302 133.026 86.057 132.994 86.0979C132.962 86.1389 132.947 86.1909 132.952 86.2429C133.501 89.875 134.642 93.3917 136.329 96.6525C136.801 97.5626 137.313 98.4498 137.866 99.3141C138.006 99.5323 138.321 99.2831 138.183 99.0664V99.0664Z"
        fill="#E6E6E6"
      />
      <path
        d="M132.948 86.6382C134.353 86.6382 135.491 85.4961 135.491 84.0872C135.491 82.6784 134.353 81.5362 132.948 81.5362C131.544 81.5362 130.406 82.6784 130.406 84.0872C130.406 85.4961 131.544 86.6382 132.948 86.6382Z"
        fill="#E6E6E6"
      />
      <path
        d="M117.843 62.2819C118.01 62.028 118.119 61.7403 118.164 61.4393C118.208 61.1384 118.186 60.8313 118.099 60.5398C118.012 60.2483 117.862 59.9795 117.661 59.7522C117.459 59.525 117.21 59.3449 116.932 59.2246L117.466 51.8484L114.124 53.726L114.129 60.4426C113.958 60.9255 113.971 61.4543 114.163 61.9288C114.355 62.4034 114.714 62.7907 115.172 63.0174C115.63 63.2441 116.154 63.2945 116.647 63.1589C117.139 63.0234 117.565 62.7113 117.843 62.2819V62.2819Z"
        fill="#FFB8B8"
      />
      <path
        d="M117.012 33.6089L117.925 57.0816L114.213 56.8747L113.387 32.2468L114.17 31.8771C114.468 31.7364 114.796 31.672 115.125 31.6895C115.454 31.707 115.773 31.8059 116.055 31.9774C116.336 32.149 116.571 32.3877 116.738 32.6724C116.905 32.9571 116.999 33.2788 117.012 33.6089Z"
        fill="#00C9D6"
      />
      <path
        d="M105.529 96.9906L103 96.9904L101.797 87.2038L105.53 87.204L105.529 96.9906Z"
        fill="#FFB8B8"
      />
      <path
        d="M101.194 96.2655H106.071V99.3464H98.1233C98.1233 98.9418 98.2027 98.5412 98.357 98.1674C98.5114 97.7936 98.7375 97.4539 99.0227 97.1679C99.3078 96.8818 99.6463 96.6548 100.019 96.5C100.391 96.3452 100.791 96.2655 101.194 96.2655Z"
        fill="#2F2E41"
      />
      <path
        d="M126.569 93.9585L124.274 95.0245L119.084 86.6506L122.471 85.0775L126.569 93.9585Z"
        fill="#FFB8B8"
      />
      <path
        d="M122.331 95.128L126.757 93.0723L128.047 95.8682L120.835 99.2182C120.493 98.4767 120.458 97.6292 120.739 96.8621C121.02 96.095 121.592 95.4713 122.331 95.128Z"
        fill="#2F2E41"
      />
      <path
        d="M99.5247 65.0516L102.133 94.9132L105.639 94.4993L108.231 67.2223L122.553 93.2575L126.266 92.2227C126.266 92.2227 114.316 56.3571 113.387 53.3562C112.37 50.0665 104.312 48.8032 104.312 48.8032L104.002 48.4927C100.54 53.1695 99.1528 59.2376 99.5247 65.0516Z"
        fill="#2F2E41"
      />
      <path
        d="M113.418 29.2861C116.216 29.2861 118.484 27.0104 118.484 24.203C118.484 21.3957 116.216 19.12 113.418 19.12C110.62 19.12 108.352 21.3957 108.352 24.203C108.352 27.0104 110.62 29.2861 113.418 29.2861Z"
        fill="#FFB8B8"
      />
      <path
        d="M116.599 34.0111L113.078 52.424C113.078 52.424 107.727 51.352 105.822 50.0606C105.067 49.5473 104.382 49.0175 103.804 48.5374C103.691 48.4443 103.584 48.3511 103.478 48.2621C102.525 47.4447 101.94 46.8362 101.94 46.8362C101.94 46.8362 102.245 45.3358 102.618 43.5601C103.035 41.5712 103.54 39.2347 103.798 38.2806C104.365 36.1882 106.313 33.7503 107.831 32.0905C108.38 31.4886 109.083 31.0481 109.863 30.8162C110.643 30.5843 111.472 30.5698 112.259 30.7743L115.007 31.4862C115.542 31.6248 116.005 31.9631 116.301 32.4322C116.597 32.9013 116.704 33.4659 116.599 34.0111Z"
        fill="#00C9D6"
      />
      <path
        opacity="0.2"
        d="M108.084 42.0533C108.084 42.0533 106.191 46.002 103.478 48.262C102.525 47.4445 101.94 46.836 101.94 46.836C101.94 46.836 102.245 45.3356 102.618 43.5599C104.891 42.3554 107.235 41.5959 108.084 42.0533Z"
        fill="black"
      />
      <path
        d="M111.442 34.8252C111.255 34.7296 111.06 34.6517 110.859 34.5925C110.447 34.4794 110.014 34.4705 109.599 34.5666C109.183 34.6627 108.798 34.8607 108.477 35.143L97.3474 43.3226L88.4956 46.31L90.0949 50.1058L103.291 46.8723L112.043 39.0684C112.344 38.7786 112.572 38.4211 112.709 38.0253C112.845 37.6296 112.885 37.2069 112.827 36.7924C112.768 36.3779 112.612 35.9833 112.371 35.6412C112.13 35.2992 111.812 35.0195 111.442 34.8252Z"
        fill="#00C9D6"
      />
      <path
        d="M113.718 29.2393C114.439 28.1564 115.008 26.6549 114.214 25.6246C113.431 24.6075 111.885 24.7574 110.685 24.3073C109.013 23.6805 108.044 21.7102 108.346 19.9456C108.649 18.181 110.06 16.7182 111.742 16.1197C113.424 15.5212 115.321 15.7158 116.968 16.4051C118.995 17.2535 120.734 18.8948 121.464 20.9739C122.193 23.053 121.803 25.5493 120.29 27.1474C118.668 28.8606 116.122 29.3172 113.767 29.2895"
        fill="#2F2E41"
      />
      <path
        d="M121.674 23.2461C121.88 24.4032 123.145 25.0604 124.308 25.2048C125.471 25.3493 126.673 25.164 127.805 25.4674C129.801 26.0023 131.117 27.9278 131.841 29.8685C132.566 31.8092 132.887 33.9038 133.828 35.7485C134.769 37.5931 136.594 39.2194 138.652 39.0469C138.249 40.0654 137.543 40.9344 136.629 41.5351C135.715 42.1359 134.639 42.4392 133.548 42.4036C132.456 42.3681 131.402 41.9955 130.529 41.3366C129.656 40.6778 129.007 39.7647 128.67 38.7221C127.914 36.38 128.782 33.5869 127.46 31.513C126.728 30.3655 125.465 29.6904 124.246 29.089C123.028 28.4875 121.749 27.8701 120.932 26.7819C120.116 25.6936 119.952 23.975 120.959 23.0607"
        fill="#2F2E41"
      />
      <path
        d="M146.344 99.4555H80.2776C80.2124 99.4555 80.15 99.4296 80.1039 99.3833C80.0579 99.3371 80.032 99.2745 80.032 99.2091C80.032 99.1438 80.0579 99.0811 80.1039 99.0349C80.15 98.9886 80.2124 98.9627 80.2776 98.9627H146.344C146.409 98.9627 146.472 98.9886 146.518 99.0349C146.564 99.0811 146.59 99.1438 146.59 99.2091C146.59 99.2745 146.564 99.3371 146.518 99.3833C146.472 99.4296 146.409 99.4555 146.344 99.4555Z"
        fill="#3F3D56"
      />
      <path
        d="M66.312 99.4555H0.245601C0.180464 99.4555 0.117993 99.4296 0.0719338 99.3833C0.025875 99.3371 0 99.2745 0 99.2091C0 99.1438 0.025875 99.0811 0.0719338 99.0349C0.117993 98.9886 0.180464 98.9627 0.245601 98.9627H66.312C66.3771 98.9627 66.4396 98.9886 66.4856 99.0349C66.5317 99.0811 66.5576 99.1438 66.5576 99.2091C66.5576 99.2745 66.5317 99.3371 66.4856 99.3833C66.4396 99.4296 66.3771 99.4555 66.312 99.4555Z"
        fill="#3F3D56"
      />
      <path
        d="M42.4502 96.7626L44.8678 96.0182L43.1566 86.308L39.5886 87.4067L42.4502 96.7626Z"
        fill="#FFB8B8"
      />
      <path
        d="M50.219 96.8351L42.6211 99.1747L41.7202 96.2293L46.3825 94.7937C47.1611 94.5539 48.0027 94.6343 48.7222 95.0172C49.4416 95.4 49.9801 96.054 50.219 96.8351Z"
        fill="#2F2E41"
      />
      <path
        d="M20.9987 96.8184H23.5276L24.7305 87.0318L20.9983 87.032L20.9987 96.8184Z"
        fill="#FFB8B8"
      />
      <path
        d="M28.4045 99.1743L20.4569 99.1746L20.4568 96.0937L25.3337 96.0935C26.1481 96.0934 26.9292 96.418 27.5051 96.9958C28.081 97.5735 28.4045 98.3572 28.4045 99.1743Z"
        fill="#2F2E41"
      />
      <path
        d="M21.6423 64.3101C21.4346 64.1273 21.2693 63.9011 21.1581 63.6473C21.0469 63.3936 20.9925 63.1184 20.9988 62.8413C21.005 62.5642 21.0718 62.2918 21.1943 62.0433C21.3168 61.7948 21.4921 61.5764 21.7079 61.4032L23.6686 36.6316L27.6559 37.6311L24.4634 61.7951C24.7292 62.1781 24.8458 62.6457 24.791 63.1091C24.7362 63.5726 24.5139 63.9998 24.1662 64.3098C23.8185 64.6198 23.3695 64.7911 22.9043 64.7911C22.4392 64.7912 21.9901 64.62 21.6423 64.3101Z"
        fill="#FFB8B8"
      />
      <path
        d="M31.071 27.2311C33.869 27.2311 36.1372 24.9553 36.1372 22.148C36.1372 19.3407 33.869 17.0649 31.071 17.0649C28.2731 17.0649 26.0049 19.3407 26.0049 22.148C26.0049 24.9553 28.2731 27.2311 31.071 27.2311Z"
        fill="#FFB8B8"
      />
      <path
        d="M24.1514 37.1234C22.9474 35.4651 22.9103 33.181 24.2072 31.5948C25.0536 30.5597 26.4692 29.7313 28.8328 29.7313C35.1328 29.7313 37.5225 34.7446 37.5225 34.7446C37.5225 34.7446 40.1294 39.5399 38.6087 43.8992C37.088 48.2586 37.088 48.6945 37.088 48.6945L27.0949 47.8226C27.0949 47.8226 28.7807 43.5 24.1514 37.1234Z"
        fill="white"
      />
      <path
        d="M21.0701 41.4627L23.2229 34.396C23.367 33.9228 23.6131 33.4871 23.9435 33.1198C24.2739 32.7525 24.6807 32.4625 25.1352 32.2703C25.5896 32.0781 26.0805 31.9884 26.5733 32.0075C27.0661 32.0266 27.5487 32.154 27.987 32.3808C28.7474 32.776 29.3296 33.4465 29.6156 34.2564C29.9015 35.0663 29.8698 35.955 29.5268 36.7423L26.7899 42.9961L21.0701 41.4627Z"
        fill="white"
      />
      <path
        d="M36.8708 47.6045L45.3432 91.634L40.7811 92.9418L29.7018 63.9521L24.7052 93.5957L19.9259 94.2496C19.9259 94.2496 17.8294 55.0274 27.0949 47.8225L36.8708 47.6045Z"
        fill="#2F2E41"
      />
      <path
        d="M48.2582 43.0345C48.1848 43.1222 48.1184 43.2156 48.0596 43.3138L37.8421 43.8108L35.8747 37.7843L32.4585 39.4134L35.6738 48.3894L48.3102 45.9099C48.6071 46.2351 48.9957 46.462 49.4242 46.5603C49.8528 46.6585 50.301 46.6236 50.7093 46.46C51.1176 46.2965 51.4666 46.0121 51.7099 45.6447C51.9531 45.2773 52.0792 44.8443 52.0712 44.4033C52.0632 43.9623 51.9216 43.5342 51.6652 43.1759C51.4089 42.8176 51.0498 42.5461 50.6359 42.3975C50.222 42.2489 49.7728 42.2302 49.3481 42.344C48.9233 42.4578 48.5432 42.6987 48.2582 43.0345V43.0345Z"
        fill="#FFB8B8"
      />
      <path
        d="M30.9191 35.3772C30.8614 34.8858 30.9121 34.3877 31.0674 33.9181C31.2228 33.4484 31.479 33.0188 31.8181 32.6595C32.1572 32.3001 32.5707 32.0199 33.0296 31.8386C33.4885 31.6573 33.9814 31.5794 34.4737 31.6103C35.3283 31.6653 36.13 32.0444 36.7164 32.6706C37.3027 33.2968 37.6298 34.1234 37.6312 34.9826V41.8126L31.7796 42.716L30.9191 35.3772Z"
        fill="white"
      />
      <path
        d="M32.1853 27.277C31.4249 27.2737 30.8383 26.4704 30.8724 25.7083C30.9065 24.9461 31.4167 24.2756 32.0314 23.8264C32.646 23.3773 33.3669 23.1038 34.0524 22.7736C34.7378 22.4434 35.4173 22.0315 35.8406 21.3977C36.0962 20.9828 36.2488 20.5124 36.2856 20.0261C36.3223 19.5397 36.2421 19.0516 36.0516 18.6028C35.6578 17.7053 34.9815 16.962 34.1265 16.4869C32.8542 15.7469 31.3529 15.5087 29.9152 15.8188C28.4943 16.1316 26.3768 16.9975 25.5443 18.1944L24.6763 20.5656C23.7919 21.6327 24.4766 23.2175 25.0203 24.4936C25.564 25.7698 26.7216 26.73 28.0279 27.1864C29.3533 27.6138 30.772 27.6564 32.1205 27.3095"
        fill="#2F2E41"
      />
      <path
        d="M27.5552 19.3795C27.182 18.7795 26.5353 18.3979 25.8667 18.1739C25.0921 17.9145 24.2683 17.8379 23.4594 17.9501C22.6505 18.0624 21.8783 18.3605 21.203 18.8212C20.5277 19.2818 19.9675 19.8927 19.566 20.6061C19.1645 21.3196 18.9325 22.1164 18.8881 22.9345C18.8173 24.2413 19.2251 25.5192 19.4648 26.8057C19.7044 28.0921 19.7521 29.513 19.0451 30.6129C18.5066 31.4506 17.6087 31.978 16.7224 32.4284C15.9837 32.8038 15.1846 33.156 14.3599 33.0812C13.5353 33.0064 12.7064 32.3511 12.7283 31.5206C12.4522 32.116 12.2658 32.7494 12.1752 33.3998C12.1172 34.0529 12.2776 34.7577 12.7478 35.2131C13.4312 35.8751 14.5139 35.8267 15.4531 35.6838C17.4863 35.3746 19.5451 34.7949 21.1514 33.5066C22.7577 32.2183 23.8235 30.097 23.4005 28.0778C23.2238 27.2344 22.8085 26.4644 22.473 25.671C22.1374 24.8776 21.8754 24.0097 22.0296 23.1618C22.1208 22.725 22.3065 22.3136 22.5735 21.9567C22.8406 21.5997 23.1825 21.3059 23.575 21.096C24.369 20.6819 25.2774 20.5436 26.1581 20.703C26.7354 20.7981 27.4563 20.9457 27.7988 20.4697C27.8895 20.3189 27.9358 20.1454 27.9324 19.9693C27.929 19.7932 27.876 19.6217 27.7794 19.4745C27.5819 19.1835 27.3303 18.9334 27.0384 18.7379"
        fill="#2F2E41"
      />
    </g>
    <defs>
      <clipPath id="clip0_7_28072">
        <rect
          width="51.3607"
          height="51.5323"
          fill="white"
          transform="translate(44.3477 0.5)"
        />
      </clipPath>
      <clipPath id="clip1_7_28072">
        <rect
          width="150"
          height="99"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const IconPointSetup = (props) => <Icon component={icon} {...props} />;

export default IconPointSetup;
